import type { PayloadAction } from '@reduxjs/toolkit';

import { createAppSlice } from '../create-app-slice';
import { stateInitializer } from './state-initializer';
import { RenderingSource } from './state.type';

export const slice = createAppSlice({
	name: 'rendering',
	initialState: stateInitializer(),
	reducers: (create) => ({
		setRawRendering: create.reducer((state, action: PayloadAction<string>) => {
			state.rawBase64 = action.payload;
			state.rawChanged = true;
			state.dirty = true;
		}),
		setAiRendering: create.reducer((state, action: PayloadAction<string>) => {
			state.aiBase64 = action.payload;
			state.aiChanged = true;
			state.dirty = true;
		}),
		setCanonical: create.reducer((state, action: PayloadAction<RenderingSource>) => {
			state.canonical = action.payload;
			state.dirty = true;
		}),
		setSignature: create.reducer((state, action: PayloadAction<string>) => {
			state.signature = action.payload;
		}),
		clearDirty: create.reducer((state) => {
			state.rawChanged = false;
			state.aiChanged = false;
			state.dirty = false;
		}),
		initFromMetadata: create.reducer((state, action: PayloadAction<{ rawPath: string; aiPath: string; canonical: RenderingSource; signature: string }>) => {
			const { rawPath, aiPath, canonical, signature } = action.payload;
			state.rawBase64 = rawPath || null;
			state.aiBase64 = aiPath || null;
			state.canonical = canonical;
			state.signature = signature || '';
			state.rawChanged = false;
			state.aiChanged = false;
			state.dirty = false;
		}),
		resetRendering: create.reducer((_state) => stateInitializer())
	}),
	selectors: {
		selectRawRendering: (state) => state.rawBase64,
		selectAiRendering: (state) => state.aiBase64,
		selectCanonical: (state) => state.canonical,
		selectSignature: (state) => state.signature,
		selectRawChanged: (state) => state.rawChanged,
		selectAiChanged: (state) => state.aiChanged,
		selectRenderingDirty: (state) => state.dirty
	}
});
